/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import Footer from "./footer";
import Dropdown from "./dropdown";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const taxAuthoritiesOption = [
  {
    value: "Cục thuế TP.HCM",
    label: "Cục thuế TP.HCM",
  },
  {
    value: "Cục thuế An giang",
    label: "Cục thuế An giang",
  },
  {
    value: "Cục thuế Cần thơ",
    label: "Cục thuế Cần thơ",
  },
  {
    value: "Cục thuế Hà nội",
    label: "Cục thuế Hà nội",
  },
];
const typePeriodOption = [
  {
    value: "Kê khai theo năm",
    label: "Kê khai theo năm  ",
  },
  {
    value: "Kê khai theo quý",
    label: "Kê khai theo quý",
  },
  {
    value: "Kê khai theo tháng",
    label: "Kê khai theo tháng",
  },
  {
    value: "Lần phát sinh",
    label: "Lần phát sinh",
  },
];
const noteOption = [
  {
    value: "Kiểm toán nhà nước",
    label: "Kiểm toán nhà nước",
  },
  {
    value: "Thanh tra tài chính",
    label: "Thanh tra tài chính",
  },
  {
    value: "Thanh tra chính phủ",
    label: "Thanh tra chính phủ",
  },
  {
    value: "Cơ quan có thẩm quyền khác (nếu có)",
    label: "Cơ quan có thẩm quyền khác (nếu có)",
  },
  {
    value: "Khác",
    label: "Khác",
  },
];

const economicContentOption = [
  {
    value: "Thuế thu nhập từ tiền lương, tiền công",
    label: "Thuế thu nhập từ tiền lương, tiền công",
  },
  {
    value: "Thuế thu nhập từ hoạt động sản xuất, kinh doanh cá nhân",
    label: "Thuế thu nhập từ hoạt động sản xuất, kinh doanh cá nhân",
  },
  {
    value: "Thuế thu nhập từ vốn đầu tư vốn cá nhân",
    label: "Thuế thu nhập từ vốn đầu tư vốn cá nhân",
  },
  {
    value: "Thuế thu nhập từ chuyển nhượng vốn (không bao gồm chuyển nhượng và chứng khoáng)",
    label: "Thuế thu nhập từ chuyển nhượng vốn (không bao gồm chuyển nhượng và chứng khoáng)",
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    taxID: {
      type: "input",
      value: "",
      bg: false,
    },
    identifierID: {
      type: "input",
      value: "",
      bg: false,
    },
    taxAuthoritiesProvince: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    taxAuthoritiesDistrict: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    economicContent: {
      type: "select",
      value: "",
      bg: false,
      option: economicContentOption,
    },
    typePeriod: {
      type: "select",
      value: "",
      bg: false,
      option: typePeriodOption,
    },
    taxPeriod: {
      type: "input",
      value: "",
      bg: false,
    },
    moneyRefund: {
      type: "input",
      value: null,
      bg: false,
    },
    note: {
      type: "select",
      value: null,
      bg: false,
      option: noteOption,
    },
  },
];

export default function RefundRequestTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesRefundRequestTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" flexDirection={"column"} justifyContent="flex-start">
        {/* <Typography component="label" variant="caption" fontSize={14} fontWeight="bold" mb={0.5}>
          II - Nội dung đề nghị hoàn trả khoản thu ngân sách nhà nước (NSNN):
        </Typography> */}
        <Typography variant="subtitle1" fontSize={13} fontStyle="normal">
          2. Hình thức đề nghị hoàn trả
        </Typography>
        <Typography variant="subtitle1" fontSize={13} fontStyle="normal">
          2.1 Bù trừ cho khoản phải nộp NSNN:
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã số thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã định danh khoảng phải nộp (Nếu có)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                Cơ quan quản lý thu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Nội dung kinh tế (Tiểu mục)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                Kỳ thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền đệ nghị bù trừ (VNĐ)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Ghi chú
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Cơ quan thuế cấp cục
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Cơ quan thuế cấp chi cục
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Loại kỳ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Kỳ tính thuế
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (5)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (7)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (8)
              </Td>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "#fff",
                    }}
                  >
                    {index + 1}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxID.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxID?.type !== "input" ? (
                      row.taxID.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="taxID"
                        value={row.taxID.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.identifierID.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.identifierID?.type !== "input" ? (
                      row.identifierID.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="identifierID"
                        value={row.identifierID.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxAuthoritiesProvince.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesProvince?.type !== "select" ? (
                      row.taxAuthoritiesProvince.value
                    ) : (
                      <SelectTable
                        name="taxAuthoritiesProvince"
                        id={row.id.value}
                        option={
                          row.taxAuthoritiesProvince.option
                            ? row.taxAuthoritiesProvince.option
                            : defaultOption
                        }
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxAuthoritiesDistrict.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesDistrict?.type !== "select" ? (
                      row.taxAuthoritiesDistrict.value
                    ) : (
                      <SelectTable
                        name="taxAuthoritiesDistrict"
                        id={row.id.value}
                        option={
                          row.taxAuthoritiesDistrict.option
                            ? row.taxAuthoritiesDistrict.option
                            : defaultOption
                        }
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.economicContent.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.economicContent?.type !== "select" ? (
                      row.economicContent.value
                    ) : (
                      <SelectTable
                        name="economicContent"
                        id={row.id.value}
                        option={
                          row.economicContent.option ? row.economicContent.option : defaultOption
                        }
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.typePeriod.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.typePeriod?.type !== "select" ? (
                      row.typePeriod.value
                    ) : (
                      <SelectTable
                        name="typePeriod"
                        id={row.id.value}
                        option={row.typePeriod.option ? row.typePeriod.option : defaultOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxPeriod.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxPeriod?.type !== "input" ? (
                      row.taxPeriod.value
                    ) : (
                      <InputTable
                        field={"date"}
                        type={"text"}
                        id={row.id.value}
                        name="taxPeriod"
                        value={row.taxPeriod.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.moneyRefund.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.moneyRefund?.type !== "input" ? (
                      row.moneyRefund.value
                    ) : (
                      <InputTable
                        field={"date"}
                        type={"text"}
                        id={row.id.value}
                        name="moneyRefund"
                        value={row.moneyRefund.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.note.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.note?.type !== "select" ? (
                      row.note.value
                    ) : (
                      <SelectTable
                        name="note"
                        id={row.id.value}
                        option={row.note.option ? row.note.option : defaultOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Td
                colspan="2"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
          </tbody>
        </table>
        {/* <Footer formData={formData} /> */}
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    console.log(type);
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
